import { makeStyles } from 'tss-react/mui';

const useOAuthEmailPanelStyles = makeStyles()((theme) => ({
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    width: '100%',
  },
}));

export default useOAuthEmailPanelStyles;
